import React, {Component, Fragment, useEffect, useState} from "react";
import {createRoot} from 'react-dom/client';
import {MapPage} from './maps/map_components'
import axios from 'axios';
import DynamicZone from "./shared/DynamicZone";

import qs from 'qs'
import {getDynamicZoneQuery, STRAPI_HOME, STRAPI_HOME_TOP} from "./services/strapi";
import {ArticlePage} from "./articles/articles_components";


const root = createRoot(document.getElementById('root') as HTMLElement);


const HomePage: React.FC = function () {

    const [homeTopContent, setHomeTopContent] = useState([]);
    const [homeBottomContent, setHomeBottomContent] = useState([]);

    useEffect(() => {

        let url_query = getDynamicZoneQuery(STRAPI_HOME_TOP)


        axios.get(url_query).then((d) => {
            setHomeTopContent(d['data']['data']['content'])
        })
    }, []);

    useEffect(() => {

        let url_query = getDynamicZoneQuery(STRAPI_HOME)


        axios.get(url_query).then((d) => {
            // console.log(d['data']['data']['content']);
            setHomeBottomContent(d['data']['data']['content'])
        })
    }, []);


    return (
        <Fragment>
            <div className="row justify-content-center" style={{marginTop: '20px'}}>
                <div className="col-sm-12 col-lg-10">
                    <DynamicZone content={homeTopContent}/>
                </div>
            </div>


            <ArticlePage onlyFeatured={true} countLimit={3}/>

            <MapPage onlyFeatured={true} countLimit={3}/>



            <div className="row justify-content-center">
                <div className="col-sm-12 col-lg-10">
                    <DynamicZone content={homeBottomContent}/>
                </div>
            </div>
        </Fragment>
    )
}


root.render(
    <HomePage/>
);

